import MicroModal from 'micromodal';
import PhotoSwipeLightbox from 'photoswipe/lightbox';

export default class ModelOptions {
    constructor() {
        this.applyEvents();
    }

    applyEvents() {
        // var modal = document.querySelector('#options-modal');
        // if (modal) {
            // MicroModal.init();
        // }
        // let buttons = document.querySelectorAll('.option__button');
        // if (buttons) {
        //     buttons.forEach(button => {
        //         button.onclick = () => {
        //             const id = button.closest('.suboptions__overlay').getAttribute('data-id');
        //             const sub_id = button.getAttribute('data-subid') ? button.getAttribute('data-subid') : null;
        //             this.doModalRequest(id, sub_id, true);
        //         }
        //     });
        // }
        // const modalOpenButtons = document.querySelectorAll('.option__modal__open');
        // if (modalOpenButtons) {
        //     modalOpenButtons.forEach(button => {
        //         button.onclick = () => {
        //             const id = button.closest('.suboptions__overlay').getAttribute('data-id');
        //             this.doModalRequest(id, null, true);
        //         }
        //     });
        // }
    }

    async fetchModalContent(id, sub_id) {
        let origin = window.location.origin;
        let url = `${origin}/wp-json/royalhomes/v1/option/${id}`;
        if (sub_id) {
            url += `?suboption=${sub_id}`;
        }

        const response = await fetch(url);

        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson ? await response.json() : null;

        if (!response.ok) {
            const message = `An error has occurred fetching the career: ${response.status}`;
            throw new Error(message);
        }
        return data;
    }

    initializeOptionSelect() {
        const select = document.querySelector('#option__select');
        if (select) {
            select.addEventListener('change', (event) => {
                this.clearModal();
                const id = select.getAttribute('data-id');
                const sub_id = event.target.value;
                this.doModalRequest(id, sub_id, false);
            });
        }
    }

    initializeGalleries() {
        const lightbox = new PhotoSwipeLightbox({
            gallery: '.option__gallery',
            children: 'a',
            showHideAnimationType: 'none',
            zoomAnimationDuration: false,
            pswpModule: () => import('photoswipe')
        });
        lightbox.init();
    }

    clearModal() {
        const modalContent = document.querySelector('#options-modal-content');
        modalContent.innerHTML = '';
    }

    onClose(modal) {
        this.clearModal();
    }

    doModalRequest(id, sub_id, show) {
        const modalContent = document.querySelector('#options-modal-content');
        const loader = document.querySelector('#option__modal__skeleton');
        loader.classList.add('active');
        if (show) {
            MicroModal.show('options-modal', {
                onClose: this.onClose.bind(this)
            });
        }
        this.fetchModalContent(id, sub_id).then(response => {
            loader.classList.remove('active');
            modalContent.innerHTML = response['option_content'];
            this.initializeOptionSelect();
            this.initializeGalleries();
        }).catch(error => {
            modalContent.innerHTML = error;
        });
    }
}